export const API_URL = "https://app.signaladoc.ng/api/v2/vsm";
export const GOOGLE_KEY =
  "598136990860-etprh808l9cfpuq8sblqgqoj6q5takpn.apps.googleusercontent.com";
